import { ConstantOf } from '../utils/typeUtils';
import { Placement } from '../Popover';

export const dataHooks = {
  tooltip: 'status-indicator-tooltip',
};

export const STATUS = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  LOADING: 'loading',
} as const;

export const TOOLTIP_PLACEMENT = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
} satisfies ConstantOf<Extract<Placement, 'top' | 'right' | 'bottom' | 'left'>>;
